module.exports = __webpack_public_path__ + "img/icon_job.fe5f508.svg";